import { Card, SimpleGrid } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext, ToastrContext } from '../../contexts';
import EmptyState from './EmptyState';
import ReasonContent from './ReasonContent';
import { RenderModalCreateUpdateReason, RenderModalUpdateStatusConfirmation } from './Modal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCreateReason, fetchDocumentSupportReason, fetchReasons, fetchUpdateReason, fetchUpdateStatusReason } from './actions';

const SettingReasonBlockId = () => {
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);

  const dispatch = useDispatch();

  const { dataReason,
    dataReasonDetail,
  } = useSelector((s) => s.settingReasonBlockId);
  const [modalReason, setModalReason] = useState({
    opened: false,
    type: 'createReason',
    data: {}
  });
  const [modalStatus, setModalStatus] = useState({
    opened: false,
    type: 'updateStatusReason',
    data: {}
  });

  const handleSwitchStatus = (type, payload) => {
    if (type === 'reason') {
      setModalStatus({
        opened: true,
        type: 'updateStatusReason',
        data: payload
      });
    } else {
      setModalStatus({
        opened: true,
        type: 'updateStatusReasonDetail',
        data: payload
      });
    }
  };

  const handleSubmitSwitchStatus = () => {
    const modPayload = {
      id: modalStatus?.data?.id,
      isActive: modalStatus?.data?.value
    };
    dispatch(fetchUpdateStatusReason(modalStatus.type, modPayload, setToastr));
    setModalStatus({
      ...modalStatus,
      opened: false,
    });
  };

  const handleSubmitReason = (payload = {}) => {
    const modPayload = { message: payload.reason, isActive: payload.isActive };
    if (['createReason', 'updateReason'].includes(modalReason.type)) {
      modPayload.isRequestUnblock = payload.isRequestUnblock;
      modPayload.supportDocument = payload.isAttachFile ? payload?.supportDocument?.[0] : '';
    }
    if (modalReason.type.includes('create')) {
      dispatch(fetchCreateReason(modalReason.type, modPayload, setToastr));
    } else {
      dispatch(fetchUpdateReason(modalReason.type,
        { ...modPayload, id: modalReason?.data?.id }, setToastr));
    }
    setModalReason({ ...modalReason, opened: false });
  };

  const handleAdd = (type) => {
    setModalReason({
      opened: true,
      type: type
    });
  };

  const handleDownloadFile = (data) => {
    if (data?.supportDocument) {
      dispatch(fetchDocumentSupportReason({
        fileName: data?.supportDocument
      }));
    } else {
      setToastr({
        visible: true,
        desc: 'Dokumen Pendukung tidak ditemukan',
        type: 'danger'
      });
    }
  };

  useEffect(() => {
    dispatch(fetchReasons('dataReason'));
    dispatch(fetchReasons('dataReasonDetail'));
    setBreadcrumbs([{ name: 'Blokir & Aktifkan NIK', to: '/customer-setting' },
      'Pengaturan Alasan dan Keterangan Blokir NIK']);
  }, []);

  return (
    <div>
      <SimpleGrid breakpoints={[{ maxWidth: '74.063rem', cols: 1, spacing: 'sm' },]} cols={2} >
        <Card withBorder>
          {!dataReason.loading
            && dataReason?.data?.length > 0
            && <ReasonContent
              dataRow={dataReason?.data}
              dispatch={dispatch}
              handleAdd={() => handleAdd('createReason')}
              handleDownloadFile={handleDownloadFile}
              handleEdit={(payload) => {
                setModalReason({
                  type: 'updateReason',
                  opened: true,
                  data: payload
                });
              }}
              handleSwitchStatus={handleSwitchStatus}
              setModalReason={setModalReason}
              title="Daftar alasan blokir NIK"
              txtBtn="Tambah Alasan Blokir NIK"
              type="reason"
            />}

          {!dataReason.loading
            && dataReason?.data?.length < 1
            &&
            <EmptyState desc="Tambah alasan blokir NIK."
              handleAdd={() => handleAdd('createReason')}
              title="Belum ada daftar alasan blokir NIK"
              txtBtn="Tambah Alasan Blokir NIK" />}
        </Card>
        <Card withBorder>

          {!dataReasonDetail.loading
            && dataReasonDetail?.data?.length > 0
            && <ReasonContent
              dataRow={dataReasonDetail?.data}
              dispatch={dispatch}
              handleAdd={() => handleAdd('createReasonDetail')}
              handleEdit={(payload) => {
                setModalReason({
                  type: 'updateReasonDetail',
                  opened: true,
                  data: payload
                });
              }}
              handleSwitchStatus={handleSwitchStatus}
              setModalReason={setModalReason}
              title="Daftar keterangan blokir di MAP"
              txtBtn="Tambah Keterangan Blokir NIK di MAP"
              type="reasonDetail" />}

          {!dataReasonDetail.loading
            && dataReasonDetail?.data?.length < 1
            &&
            <EmptyState desc="Tambah keterangan blokir untuk ditampilkan di MAP."
              handleAdd={() => handleAdd('createReasonDetail')}
              title="Belum ada keterangan blokir di MAP"
              txtBtn="Tambah Keterangan Blokir NIK di MAP" />}

        </Card>
      </SimpleGrid>
      <RenderModalCreateUpdateReason handleSubmitReason={handleSubmitReason}
        modal={modalReason} setModal={setModalReason} />

      <RenderModalUpdateStatusConfirmation
        handleSubmitSwitchStatus={handleSubmitSwitchStatus}
        modal={modalStatus}
        setModal={setModalStatus}
      />
    </div>
  );
};

export default SettingReasonBlockId;
